module.exports = __webpack_public_path__ + "img/cate-2-3b541d.png";